var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',{attrs:{"archive":_vm.archive,"selectedYear":_vm.selectedYear}})
}
var staticRenderFns = []

export { render, staticRenderFns }